import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import * as FiIcons from 'react-icons/fi'
import SafeIcon from '../ui/SafeIcon'

const { FiFilter, FiCheck } = FiIcons

function SearchFilters({ filters, onFilterChange }) {
  const { t } = useTranslation()
  const [localFilters, setLocalFilters] = useState({
    category: filters.category || '',
    priceRange: filters.priceRange || [0, 1000],
    minRating: filters.minRating || 0,
    maxMoq: filters.maxMoq || '',
    inStock: filters.inStock || false,
    tradeAssurance: filters.tradeAssurance || false,
    verified: filters.verified || false,
    readyToShip: filters.readyToShip || false
  })

  const categories = [
    { id: 'all', name: t('search.allCategories') },
    { id: 'electronics', name: t('category.electronics') },
    { id: 'fashion', name: t('category.fashion') },
    { id: 'home', name: t('category.home') },
    { id: 'toys', name: t('category.toys') },
    { id: 'beauty', name: t('category.beauty') },
    { id: 'sports', name: t('category.sports') }
  ]

  const handleChange = (key, value) => {
    const newFilters = { ...localFilters, [key]: value }
    setLocalFilters(newFilters)
    // Only apply immediately for some filters or use an "Apply" button
    // For this demo, apply immediately mostly
    onFilterChange(newFilters)
  }

  const handlePriceChange = (index, value) => {
    const newRange = [...localFilters.priceRange]
    newRange[index] = parseInt(value) || 0
    handleChange('priceRange', newRange)
  }

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-5">
      <div className="flex items-center space-x-2 mb-6 border-b border-gray-100 pb-4">
        <SafeIcon icon={FiFilter} className="w-5 h-5 text-gray-500" />
        <h2 className="font-bold text-gray-900">{t('search.filter')}</h2>
      </div>

      {/* Categories */}
      <div className="mb-6">
        <h3 className="text-sm font-bold text-gray-900 mb-3">{t('nav.categories')}</h3>
        <div className="space-y-2">
          {categories.map(cat => (
            <div key={cat.id} className="flex items-center">
              <input
                type="radio"
                id={`cat-${cat.id}`}
                name="category"
                checked={localFilters.category === cat.id}
                onChange={() => handleChange('category', cat.id)}
                className="text-[#FF6600] focus:ring-[#FF6600]"
              />
              <label htmlFor={`cat-${cat.id}`} className="ml-2 text-sm text-gray-600 cursor-pointer">
                {cat.name}
              </label>
            </div>
          ))}
        </div>
      </div>

      {/* Price Range */}
      <div className="mb-6">
        <h3 className="text-sm font-bold text-gray-900 mb-3">Preis (EUR)</h3>
        <div className="flex items-center space-x-2">
          <input
            type="number"
            value={localFilters.priceRange[0]}
            onChange={(e) => handlePriceChange(0, e.target.value)}
            className="w-full px-2 py-1 text-sm border border-gray-300 rounded"
            placeholder="Min"
          />
          <span className="text-gray-400">-</span>
          <input
            type="number"
            value={localFilters.priceRange[1]}
            onChange={(e) => handlePriceChange(1, e.target.value)}
            className="w-full px-2 py-1 text-sm border border-gray-300 rounded"
            placeholder="Max"
          />
        </div>
      </div>

      {/* Features */}
      <div className="mb-6">
        <h3 className="text-sm font-bold text-gray-900 mb-3">Features</h3>
        <div className="space-y-2">
          <label className="flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={localFilters.tradeAssurance}
              onChange={(e) => handleChange('tradeAssurance', e.target.checked)}
              className="rounded text-[#FF6600] focus:ring-[#FF6600]"
            />
            <span className="ml-2 text-sm text-gray-600">{t('feature.tradeAssurance')}</span>
          </label>
          <label className="flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={localFilters.verified}
              onChange={(e) => handleChange('verified', e.target.checked)}
              className="rounded text-[#FF6600] focus:ring-[#FF6600]"
            />
            <span className="ml-2 text-sm text-gray-600">{t('suppliers.verified')}</span>
          </label>
          <label className="flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={localFilters.inStock}
              onChange={(e) => handleChange('inStock', e.target.checked)}
              className="rounded text-[#FF6600] focus:ring-[#FF6600]"
            />
            <span className="ml-2 text-sm text-gray-600">In Stock</span>
          </label>
        </div>
      </div>
    </div>
  )
}

export default SearchFilters